import { NextStaticAsset } from '../types'

/**
 * Workaround for having removed `next-images` plugin in favor of using NextJS's built-in static image handling.
 */
export const getTrueImgSrc = (src: string | NextStaticAsset): string => {
  return typeof src === 'string' ? src : src.src || ''
}
